import React from 'react';
import { TableCell } from '@mui/material';
import { WeekIndex } from '../types/TrueViewTable.types';

export const createEvaluationCells = (weekEvals: any[], weekIndex: WeekIndex, evalIndex: number, showBorder = false, isHighlighted = false) => {
  const evaluation = weekEvals[weekIndex]?.evaluations?.[evalIndex];
  const isFirstEval = evalIndex === 0;
  const isLastEval = evalIndex === 2;
  const borderStyle = isLastEval ? { borderRight: '4px solid #3b82f6' } : { borderRight: '1px solid #d1d5db' };
  const leftBorderStyle = isFirstEval ? { borderLeft: '4px solid #3b82f6' } : { borderLeft: '1px solid #d1d5db' };
  const highlightColor = isHighlighted ? '#1976d2' : `hsl(${210 + evalIndex * 20}, 30%, 98%)`;
  const textColor = isHighlighted ? 'white' : '#374151';
  
  return [
    <TableCell 
      key={`${weekIndex}-${evalIndex}-title`} 
      sx={{
        p: 2,
        fontSize: '12px',
        color: textColor,
        backgroundColor: highlightColor,
        maxWidth: '70px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...leftBorderStyle
      }}
    >
      {evaluation?.title || 'N/A'}
    </TableCell>,
    <TableCell 
      key={`${weekIndex}-${evalIndex}-score`} 
      align="center"
      sx={{
        p: 2,
        fontSize: '13px',
        color: textColor,
        backgroundColor: highlightColor,
        borderLeft: '1px solid #d1d5db',
        fontWeight: evaluation?.score !== 'N/A' ? 600 : 400
      }}
    >
      {evaluation?.score || 'N/A'}
    </TableCell>,
    <TableCell 
      key={`${weekIndex}-${evalIndex}-date`} 
      align="center"
      sx={{
        p: 2,
        fontSize: '13px',
        color: textColor,
        backgroundColor: highlightColor,
        borderLeft: '1px solid #d1d5db',
        ...borderStyle
      }}
    >
      {evaluation?.date || 'N/A'}
    </TableCell>
  ];
};

export const generateWeekCells = (weekEvals: any[], weekIndex: WeekIndex, isHighlighted = false) => {
  const cells = [];
  for (let evalIndex = 0; evalIndex < 3; evalIndex++) {
    const isLastEval = evalIndex === 2;
    cells.push(...createEvaluationCells(weekEvals, weekIndex, evalIndex, isLastEval, isHighlighted));
  }
  return cells;
};